import { Link } from "react-router";
import { ZweiFaktorVerwalten } from "../../components/ZweiFaktor";
import { PageHead } from "../../components/ui";
import { t } from "../../lib/sprache";
import { EigenerKopf } from "../../components/shell/Logo";

/**
 * Konto · Sicherheit fürs Team: zweiter Faktor per Authenticator-App (Baustein ZweiFaktorVerwalten, den auch das
 * Creator-Konto mit eigenem Erklärtext nutzt). Geldaktionen verlangen ihn, sobald er eingerichtet ist oder die Agentur ihn fürs Team vorschreibt (0061).
 */
export function Sicherheit() {
  // Kopf mit CreatorOffice-Logo wie die übrigen eigenständigen Seiten (Portal einheitlich); vorher ohne Logo und Kopfzeile
  return (
    <>
    <EigenerKopf />
    <main id="main" className="content">
      {/* Eigener Tab-Titel außerhalb der Portalrahmen (SICHT-OEFFENTLICH-BETRIEB-33) */}
      <title>{`${t("Sicherheit", "Security")} · CreatorOffice`}</title>
      <PageHead title={t("Sicherheit", "Security")} eyebrow={t("Dein Konto", "Your account")} text={t("Zweiter Faktor für die Anmeldung", "Second factor for signing in")}>
        <Link className="btn" to="/agentur">{t("Zurück", "Back")}</Link>
      </PageHead>
      <ZweiFaktorVerwalten />
    </main>
    </>
  );
}
